'use client';

import '@mysten/dapp-kit/dist/index.css';
import { SuiClientProvider, WalletProvider, createNetworkConfig } from '@mysten/dapp-kit';
import { getFullnodeUrl } from '@mysten/sui/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import {

  lightTheme,
  type ThemeVars,
} from '@mysten/dapp-kit';
import { DEFAULT_RPC } from '@/config';
const { networkConfig } = createNetworkConfig({
  // 自定义一个名字，比如 mainnetCustom
  mainnet: {
    url: DEFAULT_RPC,
  },
  testnet: { url: getFullnodeUrl('testnet') },
});

// 自定义一个主题，改按钮颜色、圆角、字体大小等
const customTheme: ThemeVars = {
  ...lightTheme,
  backgroundColors: {
    ...lightTheme.backgroundColors,
    // primaryButton: 'rgba(255, 255, 255, 0.06)',        // 按钮背景色
    // primaryButtonHover: 'rgba(255, 255, 255, 0.06)',
    // hover 颜色

  },
  colors: {
    ...lightTheme.colors,
    // primaryButton: '#ffffff',        // 按钮文字颜色
  },
  radii: {
    ...lightTheme.radii,
    // large: '9999px',                 // 超圆角，做成 pill 按钮
  },
  fontSizes: {
    ...lightTheme.fontSizes,
    medium: '14px',                  // 按钮文字大小
  },
};

export default function AppProviders({ children }: { children: React.ReactNode }) {
  // 用 useState 确保只创建一次
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <SuiClientProvider
        networks={networkConfig}
        // defaultNetwork="mainnetCustom"
        defaultNetwork="mainnet"
      >
        <WalletProvider
          storageKey="sui-wallet"  // ✅ 添加 storageKey 确保连接状态持久化
          autoConnect  // ✨ 关键：启用 Slush（名字会显示在连接弹窗里）
          slushWallet={{ name: 'My DApp' }} theme={customTheme}>
          {children}
        </WalletProvider>
      </SuiClientProvider>
    </QueryClientProvider>
  );
}
